import { Box } from "@mui/material";
import { useTranslation } from "@localization/useTranslation";
import { EntityType } from "@common/Common.types";
import DotLegalNote from "../dotlegalNote/DotLegalNote";
import TopBarTile from "./TopBarTile";

export interface ITopBarNoteTileProps {
    note: string | undefined;
    postUrl: string;
    entityType: EntityType;
    entityId?: string;
    disabled?: boolean;
    isLoading?: boolean;
    label?: string;
    onNoteUpdated: () => void;
}

// The note button is an IconButton; the base tile's flex-column stretch would otherwise widen its circular hover fill
// into an oval, so it is centered (and un-padded) here. Most entity top bars share this exact note tile.
function TopBarNoteTile(props: ITopBarNoteTileProps) {
    const { translateString } = useTranslation();
    return (
        <TopBarTile label={props.label ?? translateString("note")} isLoading={props.isLoading}>
            <Box sx={{ display: "flex", justifyContent: "center", "& .MuiIconButton-root": { padding: 0 } }}>
                <DotLegalNote
                    note={props.note}
                    onNoteUpdated={props.onNoteUpdated}
                    postUrl={props.postUrl}
                    entityId={props.entityId}
                    entityType={props.entityType}
                    disabled={props.disabled}
                />
            </Box>
        </TopBarTile>
    );
}

export default TopBarNoteTile;
